import CrownForm, {Response} from "./scripts/CrownForm";
import "./scripts/job-filters";
import "./scripts/percentage-circle";
import Tracking from "./scripts/Tracking";

import "./style.scss";

const consentEvt = (e: Event) => {
  const acceptedCategories = (<CustomEvent>e).detail || {};

  if (acceptedCategories?.performance) {
    const tracking = new Tracking();
    tracking.init();
  } else {
    Tracking.clear();
  }
};

window.addEventListener("cf_consent", consentEvt);
window.addEventListener("cf_consent_loaded", consentEvt);

document.documentElement.style.setProperty(
  "--header-height",
  document.querySelector<HTMLElement>(".header")!.offsetHeight + "px"
);

document.addEventListener("touchstart", () => {
  return false;
});

const navToggle = document.querySelector("#navigation-toggle");
if (navToggle) {
  navToggle.addEventListener("click", (e) => {
    e.preventDefault();

    document.body.classList.toggle("navigation-opened");
  });
}

const navLinks = document.querySelectorAll(".navigation__link");
for (const navLink of navLinks) {
  navLink.addEventListener("click", (e: Event) => {
    const item = navLink.closest(".navigation__item");
    const dropdown = item?.querySelector(".navigation__dropdown");

    if (!item || !dropdown) return;

    e.preventDefault();

    item.classList.toggle("navigation__item--opened");
  });
}

const notificationToggles = document.querySelectorAll(".notifications__toggle");
for (const toggle of notificationToggles) {
  toggle.addEventListener("click", (e) => {
    e.preventDefault();

    const accordion = (e.target as HTMLElement).closest<HTMLDetailsElement>(
      ".notifications__item"
    );

    if (!accordion) return;

    accordion.open = !accordion.open;
  });
}

const applyForm = document.querySelector<HTMLFormElement>("#apply");
if (applyForm) {
  new CrownForm({
    el: applyForm,

    url: "/wp-content/themes/crowncareers/ajax/Apply.php",

    button: {
      defaultText: "Submit Your Application",
      submittingText: "Processing Your Application...",
    },

    files: {
      "apply-cv": {
        allowedExtensions: ["pdf", "doc", "docx", "rtf", "png", "jpeg", "jpg"],
        maxFileSize: 4 * 1024 * 1024,
        handle([cv]) {
          if (!cv) return;

          const cvLabel = this.el.querySelector(".form__file-label");

          if (cvLabel) {
            cvLabel.innerText = cv.name;
          }
        },
      },
    },

    success(response: Response) {
      const successMessage =
        document.querySelector<HTMLElement>("#apply-success")!;

      applyForm.remove();

      document.querySelector("#applyName")!.textContent =
        response.form_data.fullname;
      successMessage.classList.add("form__feedback--show");

      // hide graphics
      document.querySelector<HTMLElement>("#form-sparks")!.style.display =
        "none";
    },

    error(response: Response) {
      const {code} = response.error;

      let errorMessage;

      if (code === "INVALID_FILE_TYPE") {
        errorMessage = "Please upload a PDF or Word document";
      } else if (code === "FILE_TOO_LARGE") {
        errorMessage = "Please upload a file smaller than 4mb";
      } else {
        errorMessage =
          "There was an error uploading your file. Please try again.";
      }

      CrownForm.addError(errorMessage, "#apply-cv");
    }
  });

  // toggle submit button in 'apply' form if right to work is checked
  const rightToWork = document.querySelector<HTMLInputElement>(
    "#apply-right-to-work"
  );
  const button = document.querySelector<HTMLButtonElement>("#apply-submit")!;

  rightToWork?.addEventListener("change", () => {
    button.disabled = !rightToWork.checked;
  });
}

const registerInterestForm =
  document.querySelector<HTMLFormElement>("#register-interest");
if (registerInterestForm) {
  new CrownForm({
    el: registerInterestForm,

    url: "/wp-content/themes/crowncareers/ajax/RegisterInterest.php",

    button: {
      defaultText: "Submit Your Details",
      submittingText: "Submitting Your Details...",
    },

    files: {
      "register-interest-cv": {
        allowedExtensions: ["pdf", "doc", "docx", "rtf", "png", "jpeg", "jpg"],
        maxFileSize: 4 * 1024 * 1024,
        handle([cv]) {
          if (!cv) return;

          const cvLabel = this.el.querySelector(".form__file-label");

          if (cvLabel) {
            cvLabel.innerText = cv.name;
          }
        },
      },
    },

    success(response: Response) {
      const successMessage = document.querySelector<HTMLElement>(
        "#register-interest-success"
      )!;

      registerInterestForm.remove();

      document.querySelector("#registerInterestName")!.textContent =
        response.form_data.fullname;
      document.querySelector("#registerInterestDepartment")!.textContent =
        response.form_data.department;
      document.querySelector("#registerInterestLocation")!.textContent =
        response.form_data.location;
      successMessage.classList.add("form__feedback--show");

      // hide graphics
      document.querySelector<HTMLElement>("#send-us-your-cv")!.style.display =
        "none";
      document.querySelector<HTMLElement>("#form-sparks")!.style.display =
        "none";
    },

    error(response: Response) {
      const {code} = response.error;

      let errorMessage;

      if (code === "INVALID_FILE_TYPE") {
        errorMessage = "Please upload a PDF or Word document";
      } else if (code === "FILE_TOO_LARGE") {
        errorMessage = "Please upload a file smaller than 4mb";
      } else {
        errorMessage =
          "There was an error uploading your file. Please try again.";
      }

      CrownForm.addError(errorMessage, "#register-interest-cv");
    }
  });

  // toggle submit button in 'apply' form if right to work is checked
  const rightToWork = document.querySelector<HTMLInputElement>(
    "#register-interest-right-to-work"
  );
  const button = document.querySelector<HTMLButtonElement>(
    "#register-interest-submit"
  )!;

  rightToWork?.addEventListener("change", () => {
    button.disabled = !rightToWork.checked;
  });
}
